// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { morphSepolia as _morphSepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the morphSepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2710
 * Chain Name: Morph Sepolia
 * Default Block Explorer: https://explorer-testnet.morphl2.io
 * Default RPC URL: https://rpc-testnet.morphl2.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { morphSepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: morphSepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const morphSepolia = createCommon({
	..._morphSepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
